var moduleGoogleMap = function(opts) {
  var $ = jQuery;
  var _this;

  var module = {
    init: function() {
      _this = this;

      this.modifyDOM();
      this.addEvents();

      window.googleMapsInitializer = _this.helpers.initializeMap;
      $.getScript('//maps.googleapis.com/maps/api/js?key=AIzaSyAPA1QAfBTFR_6glR4_w-8BObEB-m6zcp4&v=3.exp&libraries=geometry,places&callback=googleMapsInitializer');
    },

    modifyDOM: function() {
    },

    addEvents: function() {
      $(document).on('reInitGmaps', _this.helpers.initializeMap);
    },

    eventHandlers: {
    },

    helpers: {
      initializeMap: function() {
        var defaultOpts = {
          disableDefaultUI: true,
          zoomControl: true,
          scrollwheel: false
        };

        $('.google-map').each(function() {
          if (!$(this).is(':visible')) {
            return;
          }

          if ($(this).hasClass('initialized')) {
            return;
          }

          var $markers = $(this).find('.marker');
          var opts = {};

          // .thumbnail also hides 'Google' image with css
          if ($(this).hasClass('thumbnail')) {
            opts.zoomControl = false;
          }

          var map = new google.maps.Map($(this)[0], $.extend(defaultOpts, opts));

          map.markers = [];

          $markers.each(function() {
            _this.helpers.addMarker(map, $(this));
          });

          _this.helpers.centerMap(map);
          _this.helpers.styleMap(map);
          $(this).addClass('initialized');
        });
      },

      addMarker: function(map, $marker) {
        var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

        var marker = new google.maps.Marker({
          position: latlng,
          map: map
        });

        map.markers.push(marker);

        // if marker contains HTML, add it to an infoWindow
        if ($marker.html()) {
          var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
          });

          google.maps.event.addListener(marker, 'click', function() {
            infowindow.open(map, marker);
          });
        }
      },

      centerMap: function(map) {
        var bounds = new google.maps.LatLngBounds();

        $.each(map.markers, function(i, marker) {
          var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
          bounds.extend(latlng);
        });

        if (map.markers.length === 1) {
          map.setCenter(bounds.getCenter());
          map.setZoom(14);
        } else {
          map.fitBounds(bounds);
        }
      },

      styleMap: function(map) {
        var styles = [
              {
                  "featureType": "landscape.man_made",
                  "elementType": "geometry",
                  "stylers": [
                      {
                          "color": "#f7f1df"
                      }
                  ]
              },
              {
                  "featureType": "landscape.natural",
                  "elementType": "geometry",
                  "stylers": [
                      {
                          "color": "#d0e3b4"
                      }
                  ]
              },
              {
                  "featureType": "landscape.natural.terrain",
                  "elementType": "geometry",
                  "stylers": [
                      {
                          "visibility": "off"
                      }
                  ]
              },

              {
                  "featureType": "poi.medical",
                  "elementType": "geometry",
                  "stylers": [
                      {
                          "color": "#fbd3da"
                      }
                  ]
              },
              {
                  "featureType": "poi.park",
                  "elementType": "geometry",
                  "stylers": [
                      {
                          "color": "#bde6ab"
                      }
                  ]
              },
              {
                  "featureType": "road",
                  "elementType": "geometry.stroke",
                  "stylers": [
                      {
                          "visibility": "off"
                      }
                  ]
              },

              {
                  "featureType": "road.highway",
                  "elementType": "geometry.fill",
                  "stylers": [
                      {
                          "color": "#ffe15f"
                      }
                  ]
              },
              {
                  "featureType": "road.highway",
                  "elementType": "geometry.stroke",
                  "stylers": [
                      {
                          "color": "#efd151"
                      }
                  ]
              },
              {
                  "featureType": "road.arterial",
                  "elementType": "geometry.fill",
                  "stylers": [
                      {
                          "color": "#ffffff"
                      }
                  ]
              },
              {
                  "featureType": "road.local",
                  "elementType": "geometry.fill",
                  "stylers": [
                      {
                          "color": "black"
                      }
                  ]
              },
              {
                  "featureType": "transit.station.airport",
                  "elementType": "geometry.fill",
                  "stylers": [
                      {
                          "color": "#cfb2db"
                      }
                  ]
              },
              {
                  "featureType": "water",
                  "elementType": "geometry",
                  "stylers": [
                      {
                          "color": "#a2daf2"
                      }
                  ]
              }
        ];

        var styledMap = new google.maps.StyledMapType(styles, { name: 'Styled Map' });

        map.mapTypes.set('map_style', styledMap);
        map.setMapTypeId('map_style');
      }
    }
  };

  module.init();
};
